import { ReportDeliverySettings } from '@flexible-reports/store/api/subscriptions/types';

export interface FlexibleReport {
  readonly id: string;
  readonly reportId: string | null;
  readonly status: string;
  readonly failureCode: string | null;
  readonly lastRun: string | null;
  readonly createdAt: string | null;
  readonly reportPeriod: {
    readonly datePeriod?: {
      readonly startDate: string;
      readonly endDate: string;
    };
    readonly preset?: string;
  };
  readonly recipients: string[] | null;
}

// Ads Domain model
// https://domain-model.tada.amazon.dev/tree?entity=ScheduledReport
export interface ScheduledReport {
  readonly scheduledReportId: string;
  readonly reportConfigurationId: string;
  readonly reportId: string;
  readonly status: ScheduledReportStatus;
  readonly failureCode: string | null;
  readonly creationDateTime: string;
  readonly scheduledDateTime: string;
  readonly lastUpdatedDateTime: string;
  readonly deliverySettings: ReportDeliverySettings;
  readonly period: ScheduledReportPeriod;
}

export enum ScheduledReportStatus {
  SCHEDULED = 'SCHEDULED',
  PROCESSING = 'PROCESSING',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED'
}

export interface ScheduledReportCreate {
  reportConfigurationId: string;
}

export interface ScheduledReportPeriod {
  readonly datePeriod?: {
    readonly startDate: string;
    readonly endDate: string;
  };
  readonly reportConfigurationPresetPeriod?: {
    readonly preset: string;
  };
}

export interface ScheduledReportMultiStatusSuccess {
  readonly index: number;
  readonly scheduledReport: ScheduledReport;
}

export enum ReportStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  FAILED = 'FAILED'
}
